/**
 * Attribute directive that can add demo functionality to any button or element
 * Clicking an element with this attribute will open the demo overlay with the
 * correct form selected
 */
(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('tvDemo', ['$rootScope', 'hubspotService', '$window', function ($rootScope, hubspotService, $window) {
            return {
                restrict: 'A',
                scope: {
                    demoType: '@', // demo type (normal, dynamic personalization, etc)
                    source: '@', // generally the page we're on (e.g. homepage)
                    instance: '@', // which specific button the page (e.g. hero, footer, etc)
                },
                link: function (scope, element) {
                    const defaultType = 'standard-demo';

                    console.log(`Scheduling demo type: ${scope.demoType}`);

                    if (!scope.demoType) {
                        scope.demoType = defaultType;
                    }

                    element.on('click', ($event) => {
                        if ($event) $event.preventDefault();

                        let url = 'https://www.thankview.com/set-up-demo';
                        if (scope.demoType === 'trial') {
                            url = 'https://www.thankview.com/free-trial';
                        }
                        if (scope.source === 'example') {
                            url += '?hpex=&utm_source=homepageexample';
                        }

                        $window.location = url;
                    });
                },
            };
        }]);
}());
